import { __decorate } from "tslib";
import { Menu } from '@microsoft/fast-foundation';
import { attr } from '@microsoft/fast-element';
import { ChameleonPrefixedElementMixin } from '../common/mixin';
import { DEV } from 'esm-env';
export class NavigationDrawerComponent extends ChameleonPrefixedElementMixin(Menu, 'navigation-drawer') {
    connectedCallback() {
        super.connectedCallback();
        this.propagateSizeAttribute(this.getAttribute('size'));
        this.setAccessibleLabel();
    }
    sizeChanged(_oldValue, newValue) {
        this.propagateSizeAttribute(newValue);
    }
    propagateSizeAttribute(newSize) {
        const items = this.querySelectorAll(`${this.tagFor('navigation-drawer-item')}, ${this.tagFor('navigation-drawer-link')}`);
        items?.forEach((item) => {
            if (newSize) {
                item.setAttribute('size', newSize);
            }
            else {
                item.removeAttribute('size');
            }
        });
    }
    getNavDrawerHeaderTextContent() {
        const navDrawerHeader = this.querySelector(this.tagFor('navigation-drawer-header'));
        return navDrawerHeader?.textContent;
    }
    setAccessibleLabel() {
        if (this.labelId) {
            this.setAttribute('aria-labelledby', this.labelId);
            return;
        }
        if (this.getNavDrawerHeaderTextContent()?.length) {
            this.setAttribute('aria-label', this.getNavDrawerHeaderTextContent() ?? '');
            return;
        }
        if (DEV) {
            this.validateAccessibleLabel();
        }
    }
    validateAccessibleLabel() {
        if (!this.getAttribute('aria-label')?.length && !this.getAttribute('aria-labelledby')?.length) {
            console.error(`CHAMELEON-A11Y: Navigation Drawer component must have an accessible label provided by either 
  1) text content in a Navigation Header component 
  2) a visible label whose id is given as the attribute labelId
`);
        }
    }
}
__decorate([
    attr
], NavigationDrawerComponent.prototype, "size", void 0);
__decorate([
    attr({ attribute: 'label-id' })
], NavigationDrawerComponent.prototype, "labelId", void 0);
